import InfoSignUp from "../../components/InfoSignUp/InfoSignUp";
import snkImage from "../../assets/images/snk.webp";

const SyaratDanKetentuanNew = () => {
  return (
    <div>
      <div
        className="text-white fw-bold"
        style={{
          height: "395px",
          fontSize: "3rem",
          backgroundImage: `url('${snkImage}')`,
        }}
      >
        <div className="d-flex flex-center h-100 w-100 " style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="syarat-dan-ketentuan flex-center">Syarat dan Ketentuan</div>
        </div>
      </div>
      <section className="py-5">
        <div className="container snk" style={{ fontSize: "1.25rem" }}>
          <div>
            <p style={{ fontWeight: "bold", textDecoration: "underline" }}>Syarat dan Ketentuan Lelang Caready</p>
            <p>
              PT Balai Lelang Caready (“Caready”) merupakan Badan Hukum Indonesia berbentuk Perseroan Terbatas yang
              khusus didirikan untuk melakukan kegiatan usaha di bidang lelang. Caready telah memperoleh izin
              operasional Balai Lelang berdasarkan Keputusan Menteri Keuangan Republik Indonesia Nomor 113/KM.6/2019
              tanggal 7 Mei 2019.
            </p>
            <p>
              Syarat & ketentuan yang ditetapkan di bawah ini mengatur penggunaan jasa lelang yang ditawarkan oleh PT
              Balai Lelang Caready melalui situs www.caready.co.id dan/atau aplikasi Caready. Syarat dan Ketentuan ini
              merupakan kesepakatan yang sah dan berlaku mengikat antara Caready dengan Pengguna terkait penggunaan jasa
              lelang Caready. Pengguna disarankan untuk memperhatikan dengan seksama atas Syarat dan Ketentuan terkait
              hak dan kewajiban yang timbul terkait penggunaan jasa lelang Caready.
            </p>
            <p>
              Pengguna dianggap telah membaca, mengerti, memahami dan menyetujui serta bersedia untuk tunduk dan
              mengikatkan diri pada seluruh isi dari Syarat dan Ketentuan ini dan pernyataan ini diberikan dalam keadaan
              sadar, sehat jasmani dan rohani serta tanpa paksaan dari pihak manapun sehingga berlaku sah dan mengikat
              Caready dan Pengguna.
            </p>
          </div>

          <div>
            <ol type="I" style={{ lineHeight: "170%" }}>
              {/* I */}
              <li>
                <div>Ketentuan Sebelum Lelang</div>
                <ol type="A">
                  {/* I.A */}
                  <li>
                    <div>Pendaftaran Peserta</div>
                    <ol>
                      {/* I.A.1 */}
                      <li>
                        Pendaftaran terkait penggunaan jasa wajib dilakukan oleh Calon Peserta Lelang. Calon Peserta
                        Lelang wajib melengkapi data yang diperlukan dalam situs www.caready.co.id dan/atau aplikasi
                        Caready dan wajib menunjukkan serta menyerahkan dokumen sebagai bukti identitas diri yang sah.
                      </li>
                      {/* I.A.2 */}
                      <li>
                        Dalam hal penggunaan jasa lelang, calon peserta lelang wajib menyerahkan dokumen bukti identitas
                        diri yang sah sebagaimana diatur dalam peraturan perundang-undangan mengenai Lelang.
                      </li>
                      {/* I.A.3 */}
                      <li>
                        Calon Peserta Lelang menyatakan dan menjamin keabsahan dan kecakapan dalam melaksanakan
                        penggunaan jasa lelang.
                      </li>
                      {/* I.A.4 */}
                      <li>
                        Caready berhak menolak atau membatalkan secara sepihak atas pendaftaran calon peserta lelang
                        dalam hal menggunakan jasa lelang melalui situs www.caready.co.id dan/atau aplikasi Caready.
                      </li>
                      {/* I.A.5 */}
                      <li>
                        Caready memiliki kewenangan melaksanakan tindakan yang diperlukan atas setiap dugaan pelanggaran
                        atau kesalahan atas Syarat dan Ketentuan atau pelanggaran atau kesalahan atas ketentuan
                        peraturan perundang-undangan yang berlaku.
                      </li>
                    </ol>
                  </li>

                  {/* I.B */}
                  <li>
                    <div>Uang Jaminan Penawaran Lelang</div>
                    <ol>
                      {/* I.B.1 */}
                      <li>
                        Calon peserta lelang yang telah melakukan pendaftaran dan telah mendapatkan verifikasi atas
                        hasil pemeriksaan dan penelitian oleh Caready dapat melakukan penyetoran atau penyerahan Uang
                        Jaminan Penawaran Lelang untuk memperoleh Nomor Induk Peserta Lelang (NIPL) dan melakukan
                        penggunaan jasa lelang Caready.
                      </li>
                      {/* I.B.2 */}
                      <li>
                        Calon peserta lelang ditetapkan sebagai Peserta Lelang jika sebelumnya telah melakukan
                        penyetoran atau penyerahan Uang Jaminan Penawaran Lelang melalui virtual account yang telah
                        disampaikan oleh Caready dan diterima oleh masing-masing Pengguna / Calon Peserta Lelang.
                      </li>
                      {/* I.B.3 */}
                      <li>
                        Caready memiliki kewenangan menetapkan nilai atas Uang Jaminan Penawaran Lelang pada kesempatan
                        pertama di luar ketentuan yang telah dinyatakan dalam Syarat dan Ketentuan ini.
                      </li>
                      {/* I.B.4 */}
                      <li>
                        <div>
                          Nilai atas Uang Jaminan Penawaran Lelang yang ditetapkan oleh Caready sebagai berikut:
                        </div>
                        <ol type="a">
                          {/* I.B.4.a */}
                          <li>
                            Rp. 5.000.000 (lima juta rupiah) atas objek lelang berupa Kendaraan Bermotor roda 4 (empat)
                            per 1 (satu) NIPL;
                          </li>
                          {/* I.B.4.b */}
                          <li>
                            Rp. 1.000.000 (satu juta rupiah) atas objek lelang berupa Kendaraan Bermotor roda 2 (dua)
                            per 1 (satu) NIPL;
                          </li>
                          {/* I.B.4.c */}
                          <li>
                            Rp. 5.000.000 (lima juta rupiah) atas objek lelang berupa alat berat per 1 (satu) NIPL; dan
                          </li>
                          {/* I.B.4.d */}
                          <li>
                            Rp. 500.000 (lima ratus ribu rupiah) atas objek lelang berupa barang per 1 (satu) NIPL.
                          </li>
                        </ol>
                      </li>
                      {/* I.B.5 */}
                      <li>
                        Uang Jaminan Penawaran Lelang akan dipotong sebagai bagian dari pembayaran jika Peserta Lelang
                        menjadi Pemenang. Uang jaminan ini tidak dapat digabungkan dan hanya berlaku untuk Objek Lelang
                        tertentu sesuai ketentuan nilai yang ditetapkan oleh Caready.
                      </li>
                      {/* I.B.6 */}
                      <li>
                        Dalam hal Peserta Lelang tidak ditetapkan sebagai Pemenang Lelang, Pemenang Lelang berhak
                        memperoleh kembali Uang Jaminan Penawaran Lelang yang disetor tanpa potongan melalui
                        pemindahbukuan yang dilakukan oleh Caready kepada Peserta Lelang melalui nomor rekening yang
                        telah dinyatakan dalam sistem paling lambat 5 (lima) Hari Kerja setelah tanggal Lelang.
                      </li>
                    </ol>
                  </li>

                  {/* I.C */}
                  <li>
                    <div>
                      Gelar Griya <i>(Open House)</i>
                    </div>
                    <ol>
                      {/* I.C.1 */}
                      <li>Caready akan menyediakan waktu Gelar Griya (open house) sebelum Lelang dimulai.</li>
                      {/* I.C.2 */}
                      <li>
                        Caready telah menyusun daftar Objek Lelang dalam bentuk lot yang dapat diakses melalui situs
                        www.caready.co.id dan/atau aplikasi Caready dan/atau dokumen fisik yang menyatakan daftar objek
                        lelang dalam bentuk lot.
                      </li>
                      {/* I.C.3 */}
                      <li>
                        Keseluruhan data dan informasi yang dinyatakan dalam daftar Objek Lelang dalam bentuk lot
                        bersifat panduan. Peserta Lelang tidak dapat mengajukan keberatan, klaim atau protes dalam
                        bentuk apapun.
                      </li>
                      {/* I.C.4 */}
                      <li>
                        Objek Lelang yang telah disusun dalam daftar Objek Lelang dalam bentuk lot adalah” Sebagaimana
                        Adanya” dan” Sebagaimana Tersedia”
                      </li>
                      {/* I.C.5 */}
                      <li>
                        Peserta Lelang wajib melakukan pemeriksaan secara langsung atas Objek Lelang dan Dokumen
                        Kepemilikan Objek Lelang dengan sebaik-baiknya. Peserta Lelang bertanggung jawab secara penuh
                        atas pemeriksaan kondisi Objek Lelang dan kelengkapan dokumen Objek Lelang.
                      </li>
                      {/* I.C.6 */}
                      <li>
                        Caready berhak menolak atau membatalkan secara sepihak permohonan keluhan dari Peserta Lelang
                        terkait kondisi terkini Objek Lelang, apabila keluhan tersebut tidak disertai dengan bukti
                        dokumentasi yang menunjukkan adanya ketidaksesuaian antara kondisi fisik Objek Lelang saat Gelar
                        Griya (open house) dan setelah pelaksanaan lelang.
                      </li>
                      {/* I.C.7 */}
                      <li>
                        Peserta Lelang dilarang melakukan perubahan kondisi terkini Objek Lelang dan/atau kegiatan lain
                        yang berpotensi menimbulkan kerusakan Objek Lelang.
                      </li>
                      {/* I.C.8 */}
                      <li>
                        Peserta Lelang menyatakan dan menjamin memenuhi ketentuan dan kebijakan selama penyelenggaraan
                        Gelar Griya (open house) berlangsung oleh Caready termasuk namun tidak terbatas pada aspek
                        keamanan, keselamatan, dan kesehatan.
                      </li>
                      {/* I.C.9 */}
                      <li>
                        Caready tanpa pemberitahuan sebelumnya kepada Peserta Lelang, memiliki kewenangan untuk
                        melakukan tindakan yang perlu, seperti meminta bukti identitas diri Peserta Lelang, melarang
                        Peserta Lelang masuk, atau mengusir Peserta Lelang dari area Caready saat melaksanakan Gelar
                        Griya (open house). Tindakan tersebut dilakukan atas setiap dugaan pelanggaran yang dilakukan
                        oleh Peserta Lelang terhadap syarat dan ketentuan serta ketentuan peraturan perundang-undangan
                        yang berlaku.
                      </li>
                      {/* I.C.10 */}
                      <li>
                        Caready memiliki kewenangan untuk membatasi dan/atau menghentikan kegiatan Gelar Griya (open
                        house) jika dirasa perlu karena alasan-alasan tertentu, seperti bencana alam, kerusuhan massa,
                        dan hal lain yang dapat mengganggu dan/atau membahayakan kegiatan Gelar Griya (open house).
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>

              {/* II */}
              <li>
                <div>Ketentuan Pelaksanaan Lelang</div>
                <ol type="A">
                  {/* II.A */}
                  <li>
                    Caready melaksanakan lelang secara daring melalui sistem yang dikelola dan direkam dengan ketat.
                    Peserta dengan penawaran tertinggi akan menjadi pemenang setelah disahkan oleh pejabat lelang.
                    Penawaran yang telah dilakukan tidak dapat dibatalkan dan tidak menerima keberatan setelah lelang
                    selesai.
                  </li>
                  {/* II.B */}
                  <li>
                    Pejabat Lelang dan Caready dibebaskan dari tanggung jawab atas kerugian yang timbul diakibatkan
                    kesalahan dan/atau kelalaian yang dilakukan oleh Peserta Lelang atau pihak lain dalam proses
                    penawaran dalam lelang melalui Sistem Caready.
                  </li>
                  {/* II.C */}
                  <li>
                    <div>
                      Dalam hal terdapat Gangguan Sistem selama pelaksanaan Lelang, Pejabat Lelang berwenang mengambil
                      tindakan sebagai berikut:
                    </div>
                    <ol>
                      {/* II.C.1 */}
                      <li>
                        Pembatalan Lelang dalam hal timbul Gangguan Sistem yang tidak dapat ditanggulangi hingga
                        berakhirnya jam kerja pada hari pelaksanaan Lelang;; atau
                      </li>
                      {/* II.C.2 */}
                      <li>
                        Lelang dapat dilaksanakan dengan ketentuan tenggat waktu penawaran lelang selambat-lambatnya 2
                        (dua) jam setelah Gangguan Sistem dapat ditanggulangi dan sebelum jam kerja berakhir pada hari
                        pelaksanaan Lelang.
                      </li>
                    </ol>
                  </li>
                  {/* II.D */}
                  <li>
                    Pejabat Lelang dan Caready dibebaskan dari tanggung jawab atas kerugian yang timbul karena yang
                    terjadi pada Sistem Caready atau Lelang sesuai Ketentuan atau Peserta Lelang mengalami kegagalan
                    dalam proses penawaran Lelang yang disebabkan permasalahan pada jaringan komunikasi data atau
                    perangkat elektronik yang digunakan oleh Peserta Lelang.
                  </li>
                </ol>
              </li>

              {/* III */}
              <li>
                <div>Pembayaran dan Pengambilan Unit</div>
                <ol type="A">
                  {/* III.A */}
                  <li>
                    Pemenang wajib melakukan pemenuhan pembayaran paling lambat 4 (empat) Hari Kerja setelah tanggal
                    lelang. Caready akan melakukan pemberitahuan kepada Pemenang Lelang jika terdapat ketentuan lain
                    mengenai tenggat waktu pemenuhan pembayaran.
                  </li>
                  {/* III.B */}
                  <li>
                    <div>
                      Ketentuan Nilai atas Pemenuhan Pembayaran yang dilaksanakan oleh Pemenang Lelang atas Barang /
                      Kendaraan Bermotor terdiri dari:
                    </div>
                    <ol>
                      {/* III.B.1 */}
                      <li>Harga lelang (Harga Terbentuk)</li>
                      {/* III.B.2 */}
                      <li>
                        <div>Biaya administrasi sesuai ketentuan Caready, yaitu :</div>

                        <div>Objek Lelang Kendaraan Bermotor roda 4</div>
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th
                                style={{
                                  width: "50%",
                                  backgroundColor: "blue",
                                  color: "white",
                                }}
                              >
                                Harga Terbentuk
                              </th>
                              <th
                                style={{
                                  width: "50%",
                                  backgroundColor: "blue",
                                  color: "white",
                                }}
                              >
                                Biaya Admin
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>Rp 0 - Rp 400.000.000,00</td>
                              <td>Rp 3.000.000,00</td>
                            </tr>
                            <tr>
                              <td>&gt; Rp 400.000.000,00 - Rp 600.000.000,00</td>
                              <td>Rp 5.000.000,00</td>
                            </tr>
                            <tr>
                              <td>&gt; Rp 600.000.000,00 - Rp 800.000.000,00</td>
                              <td>Rp 8.000.000,00</td>
                            </tr>
                            <tr>
                              <td>&gt; Rp 800.000.000,00</td>
                              <td>
                                Setiap kelipatan harga terbentuk sebesar Rp. 200.000.000 (dua ratus juta rupiah),
                                Caready berhak menetapkan penambahan Biaya Admin sebesar Rp. 2.000.000 (dua juta rupiah)
                              </td>
                            </tr>
                          </tbody>
                        </table>

                        <div>Objek Lelang Kendaraan Bermotor roda 2</div>
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th
                                style={{
                                  width: "50%",
                                  backgroundColor: "blue",
                                  color: "white",
                                }}
                              >
                                Harga Terbentuk
                              </th>
                              <th
                                style={{
                                  width: "50%",
                                  backgroundColor: "blue",
                                  color: "white",
                                }}
                              >
                                Biaya Admin
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>Rp 0 - Rp. 29.999.999,00</td>
                              <td>Rp 600.000,00</td>
                            </tr>
                            <tr>
                              <td>Rp 30.000.000,00 - Rp 100.000.000,00</td>
                              <td>Rp 1.000.000,00</td>
                            </tr>
                            <tr>
                              <td>Rp 100.000.001,00 - Rp 200.000.000,00</td>
                              <td>Rp 2.000.000,00</td>
                            </tr>
                            <tr>
                              <td>Rp 200.000.001,00 - Rp 400.000.000,00</td>
                              <td>Rp 3.000.000,00</td>
                            </tr>
                          </tbody>
                        </table>

                        <div>Objek Lelang Barang</div>
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th
                                style={{
                                  width: "50%",
                                  backgroundColor: "blue",
                                  color: "white",
                                }}
                              >
                                Harga Terbentuk
                              </th>
                              <th
                                style={{
                                  width: "50%",
                                  backgroundColor: "blue",
                                  color: "white",
                                }}
                              >
                                Biaya Admin
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>Rp 0 - Rp. 29.999.999,00</td>
                              <td>Rp 300.000,00</td>
                            </tr>
                            <tr>
                              <td>Rp 30.000.000,00 - Rp 100.000.000,00</td>
                              <td>Rp 1.000.000,00</td>
                            </tr>
                            <tr>
                              <td>Rp 100.000.001,00 - Rp 200.000.000,00</td>
                              <td>Rp 2.000.000,00</td>
                            </tr>
                            <tr>
                              <td>Rp 200.000.001,00 - Rp 400.000.000,00</td>
                              <td>Rp 3.000.000,00</td>
                            </tr>
                          </tbody>
                        </table>
                      </li>
                      {/* III.B.3 */}
                      <li>Biaya pendaftaran, pajak, asuransi, dan lainnya (jika berlaku)</li>
                    </ol>
                  </li>
                  {/* III.C */}
                  <li>
                    Pemenang lelang wajib melakukan pemenuhan pembayaranatas Objek Lelang yang telah dipilih melalui
                    virtual account yang akan disampaikan bersamaan dengan data dan informasi terperinci mengenai
                    tagihan pelunasan melalui surat elektronik (e-mail) atau dapat diperhatikan pada akun Peserta Lelang
                    melalui situs www.caready.co.id dan/atau aplikasi Caready.
                  </li>
                  {/* III.D */}
                  <li>
                    Setelah Pemenang Lelang telah memenuhi pembayaran dan dinyatakan lunas, Barang dan/atau Kendaraan
                    Bermotor wajib dilakukan pengambilan selambat- lambatnya 7 (tujuh) Hari Kerja sejak tanggal efektif
                    pemenuhan pembayaran oleh Pemenang Lelang. Dalam hal Pemenang Lelang tidak melakukan pengambilan
                    Barang dan/atau Kendaraan Bermotor dengan ketentuan tenggat waktu yang telah ditetapkan, Caready
                    berhak mengenakan biaya penyimpanan sebesar Rp. 100.000 (seratus ribu rupiah) per Hari Kalender.
                    Caready berhak dan mempunyai wewenang untuk melakukan pembatalan transaksi atau mengikutsertakan
                    Barang dan/atau Kendaraan Bermotor milik Pemenang Lelang dalam Lelang dan melakukan penagihan biaya
                    penyimpanan apabila Caready telah melakukan pemberitahuan pertama dan terakhir kepada Pemenang
                    Lelang dan lamanya waktu penyimpanan Barang dan/atau Kendaraan Bermotor mencapai 90 (sembilan puluh)
                    Hari Kalender sejak tanggal pelunasan.
                  </li>
                  {/* III.E */}
                  <li>
                    Pengambilan Objek Lelang, Dokumen Kepemilikan Objek Lelang, dan Berita Acara Pemenang Lelang (BAPL)
                    yang dilakukan oleh pihak lain (kuasa/perwakilan dari Pemenang Lelang) wajib menyertakan Surat Kuasa
                    yang bermaterai dan telah dilakukan penandatanganan serta menyertakan dokumen sebagai bukti
                    identitas diri yang sah baik dari Pemenang Lelang sebagai Pemberi Kuasa dan pihak lain sebagai
                    Penerima Kuasa.
                  </li>
                  {/* III.F */}
                  <li>
                    Pemenang lelang yang melakukan pembatalan secara sepihak atas Objek Lelang yang dipilih atau tidak
                    melakukan pemenuhan pembayaran sesuai tenggat waktu yang telah dinyatakan, untuk selanjutnya
                    dinyatakan Wanprestasi. Sehubungan dengan hal tersebut, Uang Jaminan Penawaran Lelang yang telah
                    disetor secara otomatis tidak dapat dikembalikan dan Penjual atau Caready dapat melakukan tuntutan
                    ganti rugi atas Uang Jaminan Penawaran Lelang.
                  </li>
                  {/* III.G */}
                  <li>
                    Biaya pengiriman atau pemindahan atas Objek Lelang dan biaya pengurusan balik nama atas Objek Lelang
                    yang dinyatakan dalam Dokumen Kepemilikan Objek Lelang menjadi tanggung jawab Pemenang Lelang.
                  </li>
                </ol>
              </li>

              {/* IV */}
              <li>
                <div>Klaim dan Pembatalan</div>
                <ol type="A">
                  {/* IV.A */}
                  <li>
                    <div>
                      Caready dapat menerima permohonan klaim selambat-lambatnya pada saat tanggal efektif pengambilan
                      Objek Lelang oleh Pemenang Lelang dengan terlebih dahulu memenuhi syarat dan ketentuan sebagai
                      berikut:
                    </div>
                    <ol>
                      {/* IV.A.1 */}
                      <li>
                        Pemenang Lelang dapat melakukan permohonan klaim dengan alasan adanya perbedaan kondisi terkini
                        atas fisik Objek Lelang saat dilakukan pengambilan Objek Lelang dengan kondisi fisik Objek
                        Lelang saat Gelar Griya (open house). Caready berhak menolak permohonan klaim apabila perbedaan
                        kondisi atas fisik Objek Lelang disebabkan oleh proses alamiah, termasuk namun tetapi tidak
                        terbatas pada korosi, perubahan karena cuaca, dan proses alami lainnya atau timbulnya Keadaan
                        Kahar.
                      </li>
                      {/* IV.A.2 */}
                      <li>
                        Caready berhak menolak permohonan keluhan dan/atau klaim apabila permohonan keluhan dan/atau
                        klaim dilakukan oleh Pemenang Lelang pada 1 (satu) Hari Kalender setelah tanggal efektif
                        pengambilan Objek Lelang.
                      </li>
                    </ol>
                  </li>
                  {/* IV.B */}
                  <li>
                    <div>
                      Caready dapat menerima permohonan klaim dengan terlebih dahulu memenuhi syarat dan ketentuan
                      sebagai berikut:
                    </div>
                    <ol>
                      {/* IV.B.1 */}
                      <li>Dokumen Kepemilikan Objek Lelang dinyatakan dalam sengketa.</li>
                      {/* IV.B.2 */}
                      <li>
                        90 (sembilan puluh) Hari Kerja sejak tanggal efektif pengambilan Dokumen Kepemilikan Objek
                        Lelang oleh Pemenang Lelang dan/atau kuasa Pemenang Lelang dengan menyertakan dokumen yang sah
                        dan resmi mengenai hasil penelitian dan pemeriksaan atas Dokumen Kepemilikan Objek Lelang
                        dinyatakan dalam status blokir oleh kepolisian.
                      </li>
                      {/* IV.B.3 */}
                      <li>Dokumen Kepemilikan Objek Lelang dinyatakan palsu.</li>
                      {/* IV.B.4 */}
                      <li>
                        90 (sembilan puluh) Hari Kerja sejak tanggal efektif pengambilan Dokumen Kepemilikan Objek
                        Lelang oleh Pemenang Lelang dan/atau kuasa Pemenang Lelang dengan menyertakan dokumen yang sah
                        dan resmi mengenai hasil penelitian dan pemeriksaan atas Dokumen Kepemilikan Objek Lelang
                        dinyatakan dalam status duplikat.
                      </li>
                    </ol>
                  </li>
                  {/* IV.C */}
                  <li>
                    Caready dapat menerima permohonan klaim selambat-lambatnya 25 (dua puluh lima) Hari Kerja setelah
                    tanggal efektif pengambilan Dokumen Kepemilikan Objek Lelang oleh Pemenang Lelang dan/atau kuasa
                    Pemenang Lelang dengan menyertakan dokumen yang sah dan resmi mengenai hasil penelitian dan
                    pemeriksaan atas perbedaan nomor rangka dan/atau nomor mesin oleh kepolisian.
                  </li>
                  {/* IV.D */}
                  <li>
                    Caready memiliki kewenangan menolak dan tidak melakukan pemenuhan atas permohonan klaim dalam hal
                    tidak memenuhi tenggat waktu yang ditetapkan dan/atau ketidakjelasan maksud dan tujuan dilakukan
                    permohonan klaim oleh Pemenang Lelang dan/atau di luar ketentuan Hari Kerja Caready.
                  </li>
                  {/* IV.E */}
                  <li>
                    Dalam hal permohonan klaim oleh Pemenang Lelang dapat ditindaklanjuti oleh Caready, Caready akan
                    melakukan pemindahbukuan Harga Terbentuk atas Barang dan/atau Kendaraan Bermotor atau biaya
                    pemindahan dan/atau biaya reparasi atas Barang dan/atau Kendaraan Bermotor berdasarkan hasil
                    penelitian dan pemeriksaan dengan terlebih dahulu mencapai kesepakatan oleh Caready maupun Penjual
                    atas permohonan klaim yang disampaikan oleh Pemenang Lelang.
                  </li>
                  {/* IV.F */}
                  <li>
                    Caready mempunyai pertanggungjawaban secara penuh atas kerugian Barang dan/atau Kendaraan Bermotor
                    secara fisik dan Caready dibebaskan dari pertanggungjawaban atas kerugian usaha, kerugian tidak
                    langsung, dan kerugian bersifat immateriil lainnya.
                  </li>
                </ol>
              </li>

              {/* V */}
              <li>
                <div>Keadaan Kahar (force majeure)</div>
                <div>
                  Caready tidak bertanggung jawab atas keterlambatan atau kegagalan layanan timbulnya Keadaan Kahar
                  (force majeure) seperti perang, kerusuhan, bencana alam, pandemi, atau perubahan regulasi.
                </div>
              </li>

              {/* VI */}
              <li>
                <div>Penghapusan Hubungan dengan Pihak Berisiko</div>
                <ol type="A">
                  {/* VI.A */}
                  <li>
                    Peserta Lelang menyatakan dan menjamin tidak terkait dengan organisasi kriminal, premanisme atau
                    kelompok berbahaya lainnya.
                  </li>
                  {/* VI.B */}
                  <li>
                    Dalam hal Caready telah melakukan penelitian dan pemeriksaana tas Peserta Lelang dan terbukti
                    mempunyai hubungan dengan organisasi kriminal, premanisme atau kelompok berbahaya lainnya, Caready
                    berhak melakukan pembatalan transaksi Lelang tanpa terlebih dahulu melakukan pemberitahuan kepada
                    Peserta Lelang.
                  </li>
                  {/* VI.C */}
                  <li>
                    Peserta bertanggungjawab atas segala kerugian yang timbul di kemudian hari serta melepaskan dan
                    membebaskan Caready dari segala tuntutan dan/atau gugatan hukum maupun pemberian ganti rugi atau
                    pertanggungjawaban finansial yang mungkin ada dikemudian hari terkait klaim atau tuntutan dari pihak
                    manapun terhadap Objek Lelang termasuk namun tidak terbatas terkait dokumen kelengkapan Objek Lelang
                    tersebut Segala perselisihan yang timbul akan diselesaikan berdasarkan hukum Republik Indonesia.
                  </li>
                </ol>
              </li>

              {/* VII */}
              <li>
                <div>Pencegahan Tindak Pencucian Uang</div>
                <ol type="A">
                  {/* VII.A */}
                  <li>
                    Peserta Lelang dilarang menggunakan Sistem Caready untuk maksud dan tujuan pencucian uang, pendanaan
                    terorisme, atau tindakan kriminal lainnya.
                  </li>
                  {/* VII.B */}
                  <li>
                    Dalam hal Caready telah melakukan penelitian dan pemeriksaan atas Peserta Lelang dan tebukti
                    melakukan pencucian uang, pendanaan terorisme, atau tindakan kriminal lainnya, Caready berhak
                    melakukan pembatalan transaksi Lelang dan selanjutnya melakukan permohonan laporan kepada otoritas
                    yang berwenang.
                  </li>
                  {/* VII.C */}
                  <li>
                    Caready dapat melakukan pengungkatan data pribadi Peserta Lelang dan riwayat transaksi Peserta
                    Lelang untuk kepentingan proses penegakan hukum dan ketentuan yang telah diatur dalam peraturan
                    perundang-undangan.
                  </li>
                </ol>
              </li>

              {/* VIII */}
              <li>
                <div>Ketentuan Penggunaan Sistem</div>
                <ol type="A">
                  {/* VIII.A */}
                  <li>
                    Sistem Caready mencakup seluruh layanan jasa lelang secara daring melalui situs www.caready.co.id
                    dan/atau aplikasi Caready.
                  </li>
                  {/* VIII.B */}
                  <li>
                    Calonpesertalelangmenyatakandanmenjaminbertanggungjawabsepenuhnyaatas kerahasiaan akun yang dapat
                    diakses melalui situs www.caready.co.id dan/atau aplikasi Caready.
                  </li>
                  {/* VIII.C */}
                  <li>
                    Calon peserta lelang wajib melakukan pembaharuan dan kelengkapan data pada akun guna memudahkan
                    segala bentuk transaksi yang akan terlaksana terkait penggunaan jasa lelang.
                  </li>
                  {/* VIII.D */}
                  <li>
                    Caready tidak pernah meminta nama akun, kata sandi (password), atau kode verifikasi (OTP) melalui
                    SMS atau media lainnya dalam kondisi apa pun.
                  </li>
                  {/* VIII.E */}
                  <li>
                    Calon peserta lelang disarankan untuk tidak menyerahkan data terkait penggunaan jasa lelang Caready
                    kepada pihak lain atau pihak yang mengatasnamakan Caready.
                  </li>
                  {/* VIII.F */}
                  <li>
                    <div>Caready dibebaskan dari tanggung jawab atas kerugian yang timbul akibat:</div>
                    <ol>
                      {/* VIII.F.1 */}
                      <li>
                        Kesalahan dan/atau kelalaian Peserta Lelang sehingga terdapat penggunaan data pribadi Peserta
                        Lelang oleh pihak lain;
                      </li>
                      {/* VIII.F.2 */}
                      <li>
                        Kesalahan dan/atau kelalaian Peserta Lelang dalam melakukan akses situs atau tautan yang
                        diberikan oleh pihak lain;
                      </li>
                      {/* VIII.F.3 */}
                      <li>
                        Kesalahan dan/atau kelalaian Peserta Lelang dalam menyerahkan kode verifikasi atau kode OTP,
                        kata sandi (password) atau surat elektronik yang digunakan dalam melakukan pendaftaran akun jasa
                        lelang Caready melalui situs www.caready.co.id dan/atau aplikasi Caready;
                      </li>
                      {/* VIII.F.4 */}
                      <li>
                        Kesalahan dan/atau kelalaian Peserta Lelang dalam melakukan aktivitas dalam skala yang besar dan
                        bersamaan dengan akses penyelenggaraan lelang;
                      </li>
                      {/* VIII.F.5 */}
                      <li>
                        Kesalahan dan/atau kelalaian Peserta lelang baik sengaja maupun tidak sengaja yang menimbulkan
                        potensi penyelenggaraan lelang;
                      </li>
                      {/* VIII.F.6 */}
                      <li>
                        Kesalahan dan/atau kelalaian Peserta lelang yang menimbulkan potensi pelanggaran terhadap Hak
                        Kekayaan Intelektual atau privasi pihak lain;
                      </li>
                    </ol>
                  </li>
                  {/* VIII.G */}
                  <li>
                    <div>Caready dibebaskan dari tanggung jawab atas kerugian yang timbul akibat:</div>
                    <ol>
                      {/* VIII.G.1 */}
                      <li>Pemeliharaan Sistem Caready.</li>
                      {/* VIII.G.2 */}
                      <li>Timbulnya Gangguan Sistem atas Sistem Caready.</li>
                      {/* VIII.G.3 */}
                      <li>Adanya kepentingan proses penegakan hukum.</li>
                      {/* VIII.G.4 */}
                      <li>
                        Keadaan Kahar yang menyebabkan penghentian sementara proses Lelang tanpa terlebih dahulu adanya
                        pemberitahuan.
                      </li>
                    </ol>
                  </li>
                  {/* VIII.H */}
                  <li>
                    Caready dibebaskan dari tanggung jawab atas ketidakakuratan, kelengkapan atau kesinambungan Sistem
                    Caready selama penyelenggaraan Lelang.
                  </li>
                  {/* VIII.I */}
                  <li>
                    Caready dibebaskan atas kerugian langsung maupun tidak langsung atas penggunaan Sistem Caready oleh
                    Peserta Lelang.
                  </li>
                  {/* VIII.J */}
                  <li>
                    Pengguna disarankan untuk memperhatikan dengan seksama modus kejahatan atas kegiatan siber, seperti
                    intersepsi atau penyadapan illegal terhadap informasi atau dokumen elektronik dan sistem elektronik,
                    pemalsuan informasi atau dokumen elektronik dan meningkatkan keamanan perangkat yang digunakan atas
                    penggunaan jasa lelang melalui situs www.caready.co.id dan/atau aplikasi Caready.
                  </li>
                </ol>
              </li>

              {/* IX */}
              <li>
                <div>Perubahan Ketentuan</div>
                <ol type="A">
                  {/* IX.A */}
                  <li>
                    Caready memiliki kewenangan melakukan perubahan atau penambahan ketentuan pada Syarat dan Ketentuan
                    tanpa terlebih dahulu melakukan pemberitahuan.
                  </li>
                  {/* IX.B */}
                  <li>
                    Syarat dan Ketentuan terkini dinyatakan berlaku sejak tanggal efektif pemberitahuan melalui situs
                    www.caready.co.id dan dianggap memahami dan menyetujui serta bersedia untuk tunduk dan mengikatkan
                    diri pada Syarat dan Ketentuan.
                  </li>
                </ol>
              </li>

              {/* X */}
              <li>
                <div>Definisi</div>
                <ol type="A">
                  {/* X.A */}
                  <li>
                    <div>Barang</div>
                    <div>Tiap benda atau hak yang dapat dijual secara Lelang.</div>
                  </li>
                  {/* X.B */}
                  <li>
                    <div>Calon Peserta Lelang</div>
                    <div>
                      Orang, instansi atau lembaga yang dibentuk dengan peraturan perundang-undangan, yang akan
                      melakukan pendaftaran dan partisipasi dalam Lelang
                    </div>
                  </li>
                  {/* X.C */}
                  <li>
                    <div>Dokumen Kepemilikan Objek Lelang</div>
                    <div>
                      Dokumen yang menyatakan kondisi kepemilikan Objek Lelang telah dipenuhi oleh Penjual sesuai jenis
                      Lelang dan tidak ada perbedaan data, menunjukkan hubungan hukum antara Penjual dengan Barang /
                      Kendaraan Bermotor yang akan dilelang, termasuk namun tidak terbatas pada Bukti Pemilik Kendaraan
                      Bermotor (BPKB) dan Surat Tanda Nomor Kendaraan (STNK), Salinan faktur pajak, dan/atau Salinan
                      bukti pembayaran.
                    </div>
                  </li>
                  {/* X.D */}
                  <li>
                    <div>Gangguan Sistem</div>
                    <div>
                      Gangguan yang terjadi pada situs www.caready.co.id dan/atau aplikasi Caready serta infrastruktur
                      teknologi informasi dan komunikasi sehingga Lelang tidak dapat dilaksanakan.
                    </div>
                  </li>
                  {/* X.E */}
                  <li>
                    <div>Gelar Griya (Open House)</div>
                    <div>
                      Caready menyediakan waktu bagi Peserta lelang untuk melihat dan meneliti secara fisik Barang yang
                      akan dilelang.
                    </div>
                  </li>
                  {/* X.F */}
                  <li>
                    <div>Hari Kalender</div>
                    <div>Semua hari dalam satu tahun mulai dari hari Senin sampai dengan hari Minggu.</div>
                  </li>
                  {/* X.G */}
                  <li>
                    <div>Hari Kerja</div>
                    <div>
                      Jadwal Operasional Caready selama 5 (lima) hari mulai dari hari Senin sampai dengan Jumat dengan
                      waktu yang telah ditentukan antara pukul 09:00 waktu setempat sampai dengan pukul 18:00 waktu
                      setempat, kecuali hari Minggu dan hari libur nasional yang sewaktu-waktu ditetapkan oleh
                      pemerintah.
                    </div>
                  </li>
                  {/* X.H */}
                  <li>
                    <div>Harga Minimum</div>
                    <div>Nilai minimal Barang / Kendaraan Bermotor yang akan dilelang dan ditetapkan oleh Penjual.</div>
                  </li>
                  {/* X.I */}
                  <li>
                    <div>Harga Terbentuk</div>
                    <div>
                      Harga penawaran tertinggi yang diajukan oleh Peserta Lelang yang telah disahkan sebagai Pemenang
                      Lelang oleh Pejabat Lelang.
                    </div>
                  </li>
                  {/* X.J */}
                  <li>
                    <div>Keadaan Kahar (Force Majeure)</div>
                    <div>
                      Setiap peristiwa atau kejadian dan/atau rangkaian kejadian atau peristiwa yang secara rasional,
                      termasuk namun tetapi tidak terbatas pada perang, kerusuhan, bencana alam, pandemi, atau perubahan
                      regulasi yang tidak dapat diantisipasi atau dikendalikan dan/atau timbul di luar kekuasaan Caready
                      atau Penjual atau Peserta Lelang yang mengakibatkan salah satu pihak tidak dapat memenuhi
                      pelaksanaan sehubungan dengan Lelang.
                    </div>
                  </li>
                  {/* X.K */}
                  <li>
                    <div>Kendaraan Bermotor</div>
                    <div>
                      Setiap kendaraan yang digerakkan oleh peralatan mekanik berupa mesin selain kendaraan yang
                      berjalan di atas rel dengan jenis sepeda motor, kendaraan bermotor roda tiga, kendaraan bermotor
                      roda empat, kendaraan bermotor roda enam, dan kendaraan bermotor dengan roda lebih dari enam
                      disertai dengan bukti kepemilikan oleh Penjual.
                    </div>
                  </li>
                  {/* X.L */}
                  <li>
                    <div>Lelang</div>
                    <div>
                      Penjualan barang yang terbuka untuk umum dengan penawaran harga secara tertulis dan/atau lisan
                      yang semakin meningkat atau menurun untuk mencapai harga tertinggi, yang didahului dengan
                      Pengumuman Lelang.
                    </div>
                  </li>
                  {/* X.M */}
                  <li>
                    <div>Lelang Sukarela</div>
                    <div>
                      Lelang untuk melaksanakan penjualan Barang milik swasta, perorangan, atau badan hukum / badan
                      usaha yang dilelang secara sukarela.
                    </div>
                  </li>
                  {/* X.N */}
                  <li>
                    <div>Nomor Induk Peserta Lelang</div>
                    <div>
                      Nomor identifikasi yang diberikan kepada Peserta Lelang terdaftar untuk digunakan selama proses
                      Lelang.
                    </div>
                  </li>
                  {/* X.O */}
                  <li>
                    <div>Objek Lelang</div>
                    <div>Barang yang dilelang oleh Caready.</div>
                  </li>
                  {/* X.P */}
                  <li>
                    <div>Pejabat Lelang</div>
                    <div>Pejabat umum yang diberi wewenang khusus untuk melaksanakan Lelang.</div>
                  </li>
                  {/* X.Q */}
                  <li>
                    <div>Pemenang Lelang</div>
                    <div>Peserta Lelang yang mengajukan penawaran tertinggi dan disahkan oleh Pejabat Lelang.</div>
                  </li>
                  {/* X.R */}
                  <li>
                    <div>Pengguna</div>
                    <div>
                      Setiap orang pemakai jasa yang tersedia oleh Caready melalui situs www.caready.co.id dan/atau
                      aplikasi atau sistem lainnya sehubungan dengan penyelengaaraan Lelang.
                    </div>
                  </li>
                  {/* X.S */}
                  <li>
                    <div>Pengumuman Lelang</div>
                    <div>
                      Pemberitahuan kepada masyarakat tentang akan adanya Lelang dengan maksud untuk menghimpun peminat
                      Lelang dan pemberitahuan kepada pihak yang berkepentingan
                    </div>
                  </li>
                  {/* X.T */}
                  <li>
                    <div>Penjual</div>
                    <div>
                      Orang, instansi, atau Lembaga yang dibentuk dengan peraturan perundang- undangan, yang berdasarkan
                      peraturan perundang-undangan atau perjanjian berwenang menjual Barang secara Lelang.Individu atau
                      badan hukum yang memiliki kewenangan hukum untuk menjual kendaraan atau barang melalui Caready.
                    </div>
                  </li>
                  {/* X.U */}
                  <li>
                    <div>Penyelenggara Lelang</div>
                    <div>Instansi pemerintah atau institusi swasta yang menyelenggarakan Lelang.</div>
                  </li>
                  {/* X.V */}
                  <li>
                    <div>Peserta Lelang</div>
                    <div>
                      Orang, instansi atau Lembaga yang dibentuk dengan peraturan perundang- undangan, yang telah
                      memenuhi syarat untuk mengikuti Lelang.
                    </div>
                  </li>
                  {/* X.W */}
                  <li>
                    <div>Sistem Caready</div>
                    <div>
                      Platform layanan berbasis web atau aplikasi yang disediakan Caready, termasuk sistem Lelang,
                      pemeriksaan stok unit, manajemen kontrak, dan pembayaran.
                    </div>
                  </li>
                  {/* X.X */}
                  <li>
                    <div>Uang Jaminan Penawaran lelang</div>
                    <div>
                      Sejumlah uang yang disetor kepada Penyelenggara Lelang oleh Calon Peserta Lelang sebelum
                      pelaksanaan Lelang sebagai syarat menjadi Peserta Lelang.
                    </div>
                  </li>
                </ol>
              </li>
            </ol>
          </div>
        </div>
      </section>
      <InfoSignUp />
    </div>
  );
};

export default SyaratDanKetentuanNew;
